import { Reveal, MaskLines } from "./Reveal";
import { TrendingDown, Repeat, Lock } from "lucide-react";

const WALLS = [
  {
    icon: Repeat,
    title: "The Same Number, Every Year",
    body: "You cracked six figures and then stalled. The account refuses to compound, and every good month gets erased by one impulsive, oversized trade you swore you'd never take again.",
  },
  {
    icon: TrendingDown,
    title: "Your Edge Isn't The Problem",
    body: "You know your setups. You've read the books, bought the courses, watched the gurus. The strategy works — it's the trader executing it who keeps breaking under pressure.",
  },
  {
    icon: Lock,
    title: "You've Outgrown Free Advice",
    body: "Free content got you here. It won't get you out. What you need now is a private 6 figure stock trading coach who has done it, lives it, and will hold you to a higher standard.",
  },
];

export const Plateau = () => (
  <section id="wall" className="relative border-t border-white/10 py-24 sm:py-32">
    <div
      className="pointer-events-none absolute right-0 top-20 h-[50vh] w-[50vh] rounded-full opacity-[0.12] blur-3xl"
      style={{ background: "radial-gradient(circle, #d4af37, transparent 65%)" }}
    />
    <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
      <Reveal>
        <span className="font-['IBM_Plex_Mono'] text-[11px] uppercase tracking-[0.3em] text-[#d4af37]">
          Chapter 01 &mdash; The Wall
        </span>
      </Reveal>

      <h2 className="mt-8 max-w-4xl font-['Playfair_Display'] text-3xl font-medium tracking-tight sm:text-4xl lg:text-5xl">
        <MaskLines
          whileInView
          lineClass="gold-metallic-text"
          lines={["Six figures felt like freedom.", "Then it started to feel like a ceiling."]}
        />
      </h2>

      <Reveal delay={0.15} className="mt-8 max-w-2xl">
        <p className="text-base leading-relaxed text-[#a1a1aa] sm:text-lg">
          Nobody warns you about the wall. It's the moment your trading stops being about
          learning and starts being about <em className="text-[#f5f5f0] not-italic">yourself</em> &mdash;
          your risk tolerance, your ego, your discipline, your relationship with money. As a
          dedicated 6 figure stock trading coach, Shabz has walked hundreds of talented traders
          straight through it.
        </p>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 gap-px overflow-hidden border border-white/10 bg-white/10 md:grid-cols-3">
        {WALLS.map((w, i) => (
          <Reveal key={w.title} delay={i * 0.12} className="h-full">
            <div
              data-testid={`wall-card-${i}`}
              className="gold-toptrim group flex h-full flex-col gap-5 bg-[#0e0e10] p-9 transition-colors duration-300 hover:bg-[#141416]"
            >
              <w.icon className="h-7 w-7 text-[#d4af37]" strokeWidth={1.3} />
              <h3 className="font-['Playfair_Display'] text-xl font-medium text-[#f5f5f0]">
                {w.title}
              </h3>
              <p className="text-sm leading-relaxed text-[#a1a1aa]">{w.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
